import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-800 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-heading font-bold text-background-50 mb-4">贝勒漫画</h3>
            <p className="text-sm text-background-400 leading-relaxed">
              贝勒漫画网是国内领先的漫画在线阅读平台，提供韩漫、日漫、国漫等热门漫画资源，每日更新，高清畅读。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">热门分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/korean" className="text-sm text-background-400 hover:text-background-50 transition-colors duration-200 whitespace-nowrap">韩漫</Link>
              <Link to="/category/japanese" className="text-sm text-background-400 hover:text-background-50 transition-colors duration-200 whitespace-nowrap">日漫</Link>
              <Link to="/category/chinese" className="text-sm text-background-400 hover:text-background-50 transition-colors duration-200 whitespace-nowrap">国漫</Link>
              <Link to="/category/romance" className="text-sm text-background-400 hover:text-background-50 transition-colors duration-200 whitespace-nowrap">恋爱</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">快速链接</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-400 hover:text-background-50 transition-colors duration-200 whitespace-nowrap">首页</Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-background-50 transition-colors duration-200 whitespace-nowrap">关于我们</Link>
              <a href="#app-download" className="text-sm text-background-400 hover:text-background-50 transition-colors duration-200 whitespace-nowrap cursor-pointer">App下载</a>
              <a href="#" className="text-sm text-background-400 hover:text-background-50 transition-colors duration-200 whitespace-nowrap cursor-pointer">帮助中心</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">联系我们</h4>
            <div className="flex flex-col gap-2 text-sm text-background-400">
              <span>邮箱：contact@beilemanga.com</span>
              <span>QQ群：1234567890</span>
              <span>微信：beilemanga_official</span>
              <div className="flex items-center gap-3 mt-2">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-md bg-background-700 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="微博" rel="nofollow">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-md bg-background-700 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="微信" rel="nofollow">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-md bg-background-700 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="QQ" rel="nofollow">
                  <i className="ri-qq-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {currentYear} 贝勒漫画网 beilemanga.com - 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-background-300 transition-colors duration-200 whitespace-nowrap cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-background-300 transition-colors duration-200 whitespace-nowrap cursor-pointer">服务条款</a>
            <a href="#" className="hover:text-background-300 transition-colors duration-200 whitespace-nowrap cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}